import { render, staticRenderFns } from "./AddDispatch.vue?vue&type=template&id=2f490508&scoped=true"
import script from "./AddDispatch.vue?vue&type=script&lang=js"
export * from "./AddDispatch.vue?vue&type=script&lang=js"
import style0 from "./AddDispatch.vue?vue&type=style&index=0&id=2f490508&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f490508",
  null
  
)

export default component.exports